// extracted by mini-css-extract-plugin
export var label = "_e1-2";
export var slideContainer = "_e1-0";
export var slider = "_e1-1";